import { render, staticRenderFns } from "./ScriveEditSignerRole.vue?vue&type=template&id=3e4402d4&"
import script from "./ScriveEditSignerRole.vue?vue&type=script&lang=ts&"
export * from "./ScriveEditSignerRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports